// @ts-nocheck
import type { RefObject } from 'react';
import type React from 'react';
import { ActionTypes } from '../../../contexts/reducers/map-reducer';
import mapContext from '../../../contexts/map-context';
import { clearInput } from '../../../utils/clearInput';

export const useHandleInputChange = (
  enterBtnPressed: boolean,
  setEnterBtnPressed: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const dispatch = mapContext.useMapDispatch();

  return ({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
    if (value === '' && enterBtnPressed) {
      dispatch({ type: ActionTypes.setSearchText, payload: '' });
      setEnterBtnPressed(false);
      return;
    }

    dispatch({ type: ActionTypes.setSearchText, payload: value });
    if (value.length) {
      dispatch({ type: ActionTypes.resetGeolocationSearch, payload: null });
      dispatch({ type: ActionTypes.setIsAutocompletionOpen, payload: true });
    } else {
      dispatch({ type: ActionTypes.setIsAutocompletionOpen, payload: false });
    }
  };
};

export const useHandleClearInput = (
  backButtonVisible: boolean,
  inputRef: RefObject<HTMLInputElement>,
) => {
  const dispatch = mapContext.useMapDispatch();

  return () => {
    if (backButtonVisible) {
      dispatch({ type: ActionTypes.setSearchText, payload: '' });
    } else {
      dispatch({ type: ActionTypes.setSearchText, payload: '' });
      dispatch({ type: ActionTypes.setQuery, payload: '' });
      dispatch({ type: ActionTypes.setPlaceId, payload: '' });
      dispatch({
        type: ActionTypes.setResults,
        payload: {
          dealers: null,
          services: [],
        },
      });
      dispatch({ type: ActionTypes.setSelectedDealerId, payload: null });
      dispatch({ type: ActionTypes.setDealerReviews, payload: [] });
      dispatch({ type: ActionTypes.setLastSubmittedSearch, payload: null });
    }

    dispatch({ type: ActionTypes.setIsAutocompletionOpen, payload: false });
    dispatch({
      type: ActionTypes.setResults,
      payload: {
        dealers: null,
        services: [],
      },
    });
    if (inputRef.current) {
      clearInput(inputRef);
    }
  };
};

export const useHandleClickOnBackButton = () => {
  const dispatch = mapContext.useMapDispatch();
  const { lastSubmittedSearch } = mapContext.useMapState();

  return () => {
    dispatch({ type: ActionTypes.setSearchText, payload: lastSubmittedSearch });
    dispatch({ type: ActionTypes.setIsAutocompletionOpen, payload: false });
  };
};
